<script>
import OneLoanAttribute from './OneLoanAttribute.vue'
import { toasterMethods, hmdaMethods } from '@state/helpers'
import constant from '@constants/constant'
import copyToClipboard from '@/src/utils/copy-to-clipboard'
import format from 'date-fns/format'

export default {
  components: { OneLoanAttribute },
  props: {
    filter: { type: Object, default: () => {} },
    summary: { type: Object, default: () => {} },
    loan: { type: Object, default: () => {} },
    disablePrevBtn: { type: Boolean, default: false },
    disableNextBtn: { type: Boolean, default: false },
  },
  data() {
    return {
      modalDelete: null,
      deletionOptions: [
        {text: 'Client request', value: 'Client request'},
        {text: 'Upload failure', value: 'Upload failure'},
        {text: 'Invalid loan', value: 'Invalid loan'},
        {text: 'Other (add reason) ', value: 'other'}
      ],
      deletedOption: '',
      isDeleteWindow: false,
      otherInput:'',
      showCustomReportIssue: false,
      head1: '',
      data1: '',
      lStatus: 'Failed',
      showSpinner: true,
      loanAttributes: [],
      commentsList: [],
      commentsfieldName: '',
      isAnyUnsavedChanges: false,
      blank: '#blank',
      isIncludePassedLoans: false,
      showRateSpreadModal: false,
      actionTaken: null,
      reverseMortgageCode: null,
      loanTerm: null,
      amortizationType: 'VariableRate',
      amortizationTypes: [
        { text: 'FixedRate', value: 'FixedRate' },
        { text: 'VariableRate', value: 'VariableRate' },
      ],
      rateLockDate: null,
      apr: null,
      rateSpreadResult: null,
      rateSpreadError: false,

      propStreet: null,
      propCity: null,
      propState: null,
      propZip: null,
      propertyAddress: null,
      censusTract: null,
      showGeoCodeModal: false,
      geoCodeResult: null,
      geoCodeErrors: [],
      // geoCodeAPIError: false,
      copyGeoCode: false,
      backgroundSpinner: true,
      commentsMandate: false,
      ULIcommentsList: [],
    }
  },

  computed: {
    PROJECT_ID() {
      return this.$route.params.projectId || '0'
    },
  },

  watch: {
    loan(val) {
      this.initData(val)
    },
  },

  mounted() {
    this.showSpinner = true
    if (this.loan) {
      this.initData(this.loan)
    }
    history.pushState(null, null, document.URL)
    window.addEventListener(
      'popstate',
      () => {
        // history.pushState(null, null, document.URL)
        this.goToProjectSummary({
          name: 'hmda-project-details',
          params: { id: this.PROJECT_ID },
        })
      },
      { once: true }
    )
    let hmdaData = this.$store.state.hmdaModule.hmdaConfigData || []
    let commentReq = hmdaData.find((hmda) => hmda.configurationKey === 'commentsRequired') || null
    console.log(commentReq)
    this.commentsMandate = commentReq ?  commentReq.configurationValue === "true" : false
  },

  methods: {
    ...hmdaMethods,
    ...toasterMethods,
    formatApr(value) {
      value = value.replace(/[^0-9.]/g, '')
      if (value.indexOf('.') !== -1) {
        value = value.replace(/\.+/g, '.')
      }
      if (value !== '') {
        value = parseFloat(value).toFixed(3)
      }
      this.apr = value
    },
    isValidFormData() {
      // not putting in computed as comments don't trigger change
      let res = !(
        this.loanAttributes.filter((l) => l.newValue).length === 0 ||
        this.loanAttributes.some((l) => {
          return !l.isValid
        })
      )

      if (!res && this.commentsMandate) {
        this.setAlert({
          title: constant.imageHeaderError,
          msg: constant.formValidationErrorMsg,
          variant: constant.AlertTypes.Error,
        })
      }
      return res
    },
    stateUpdated({ item, isValid }) {
      item.isValid = isValid
      this.isAnyUnsavedChanges = this.loanAttributes.some((g) => g.isChanged)
    },
    async showComment(item) {
      this.commentsfieldName = item.name
      this.commentsList = []
      this.$bvModal.show('bv-modal-comments')
      this.showSpinner = true

      this.fetchAttrComment({
        larDetailId: this.loan.larDetailId,
        attrId: item.dataAttributeId,
      })
        .then((a) => {
          this.commentsList = a
        })
        .finally(() => {
          this.showSpinner = false
        })
    },
    async initData(loan) {
      this.loanAttributes = (loan.loanAttributes || []).map((la, index) => {
        la.hasError = la.hasError || false
        la.errorIndex = la.hasError ? index : -1
        la.isValid = true
        return la
      })
      this.showSpinner = false
    },
    executeRule() {
      this.showSpinner = true
      let payload = {
        projectId: this.loan.projectId,
        customerId: this.loan.customerId,
        TemplateId: 1,
        LarDetailIds: [this.loan.larDetailId],
        IncludePassedLoans: this.isIncludePassedLoans,
      }
      this.postRunRules(payload).finally(() => {
        this.showSpinner = false
      })
    },
    runUnsavedChanges() {
      this.$refs.msg
        .showAsync(
          constant.hmdaMessages.warnUnsavedChanges,
          'Confirm',
          constant.hmdaMessages.btnTextSaveAndRun,
          constant.hmdaMessages.btnTextIgnoreAndRun
        )
        .then(() => {
          if (this.isValidFormData()) {
            this.saveChanges().then((e) => {
              if (e && e.data && e.data.responseStatus === 1) this.executeRule()
            })
          }
        })
        .catch(() => {
          // clicks ignore and run
          this.executeRule()
        })
    },
    onClickRunRules() {
      if (this.isAnyUnsavedChanges) {
        this.runUnsavedChanges()
        return
      }
      this.$refs.msg
        .showAsync(
          constant.hmdaMessages.cfmRuleExecOnOneLoan,
          'Confirm',
          constant.hmdaMessages.btnTextRunRules
        )
        .then(() => {
          this.executeRule()
        })
        .catch(() => {})
    },
    async saveChanges() {
      if (!this.isValidFormData() && this.commentsMandate) {
        return
      }

      this.showSpinner = true

      let toUpdate = this.loanAttributes.filter((l) => l.newValue)

      let payload = toUpdate.map((l) => {
        return {
          larDetailId: this.loan.larDetailId,
          dataAttributeId: l.dataAttributeId,
          name: l.name,
          comment: l.comment,
          oldValue: l.currentValue,
          newValue: l.newValue,
        }
      })

      return this.postLoan(payload)
        .then((response) => {
          if (response && response.data && response.data.responseStatus === 1) {
            toUpdate.forEach((p) => {
              p.currentValue = p.newValue !== this.blank ? p.newValue : ''
              p.newValue = ''
              p.comment = ''
              p.hasComments = true
            })
          }
          return response
        })
        .finally(() => (this.showSpinner = false))
    },
    prevLoan() {
      if (this.isAnyUnsavedChanges) {
        this.confirmModal()
          .then(() => {
            this.saveChanges()
          })
          .catch(() => {
            // clicks discard changes
            this.$emit('prevLoan')
          })
      } else {
        this.$emit('prevLoan')
      }
    },

    nextLoan() {
      if (this.isAnyUnsavedChanges) {
        this.confirmModal()
          .then(() => {
            this.saveChanges()
          })
          .catch(() => {
            // clicks discard changes
            this.$emit('nextLoan')
          })
      } else {
        this.$emit('nextLoan')
      }
    },

    confirmModal() {
      return this.$refs.msgusc.showAsync(
        constant.hmdaMessages.warnUnsavedChanges,
        constant.imageHeaderConf,
        constant.hmdaMessages.btnTextSaveChanges,
        constant.hmdaMessages.btnTextDiscardChanges
      )
    },

    goToProjectSummary(routeObj) {
      if (this.isAnyUnsavedChanges) {
        this.confirmModal()
          .then(() => {
            // history.pushState(null, null, document.URL)
            this.saveChanges()
          })
          .catch(() => {
            // clicks discard changes
            this.$router.push({
              name: routeObj.name,
              params: routeObj.params ? routeObj.params : {},
            })
          })
      } else {
        this.$router.push({
          name: routeObj.name,
          params: routeObj.params ? routeObj.params : {},
        })
      }
    },
    onClickCustomLoanMethods(type) {
      switch(type) {
        case 'ratespread': this.onClickRateSpread()
         break
        case 'geocode': this.onClickGeoCode()
         break
      }
    },
    onClickRateSpread() {
      this.loanAttributes.map((l) => {
        switch(l.name) {
          case 'ActionTaken': this.actionTaken = l.currentValue
           break
          case 'ReverseMortgage': this.reverseMortgageCode = l.currentValue
           break
          case 'LoanTerm': this.loanTerm = l.currentValue
        }
      })
      this.loanTerm = this.loanTerm ? (Number(this.loanTerm) < 12 ? 1 : parseInt(Math.round(Number(this.loanTerm)/12)))  : ''
      // clear prev data
      this.rateSpreadResult = null
      this.showRateSpreadModal = true
    },
    closeRateSpread() {
      // turn off modal and clear user inputs/errors
      this.showRateSpreadModal = false
      this.rateSpreadError = null

      this.actionTaken = null
      this.reverseMortgageCode = null
      this.loanTerm = null

      this.amortizationType = 'VariableRate'
      this.rateLockDate = null
      this.apr = null
      setTimeout(() => {
        copyToClipboard(
        this.rateSpreadResult,
        'Rate Spread value')
      }, 0)

    },
    containsOnlyDigits(value) {
      return !isNaN(value) && !isNaN(parseFloat(value))
    },
    onClickCalculateRateSpread() {
      this.rateSpreadError = null
      this.rateSpreadResult = null
      this.$validator.validate().then((response) => {
        if (response) {
          this.showSpinner = true
          let payload = {
            actionTakenType: String(this.actionTaken),
            loanTerm: String(this.loanTerm),
            amortizationType: String(this.amortizationType),
            apr: String(this.apr),
            lockInDate: String(format(new Date(this.rateLockDate), 'YYYY-MM-DD')),
            reverseMortgage: String(this.reverseMortgageCode),
          }
          this.getRateSpreadValue(payload).then((response) => {
            if(response && response.status === 200) {
              this.rateSpreadResult = this.containsOnlyDigits(response.data.rateSpread) ? response.data.rateSpread : null || null
              this.rateSpreadError = this.rateSpreadResult ? null : 'error'
            } else this.rateSpreadError = 'error'

            if(!this.containsOnlyDigits(response.data.rateSpread)) {
              this.setAlert({
                title: constant.imageHeaderError,
                msg: response.data.rateSpread,
                variant: constant.errorMessagetype,
              })
            }

            this.showSpinner = false
          }).catch((error) => {
            this.showSpinner = false
            this.authError = error
            this.setAlert({
              title: constant.imageHeaderError,
              msg: constant.errorMessage,
              variant: constant.errorMessagetype,
            })
         })
        }
      })
    },
    copyToClipboardValue(type) {
      var test
      if(type === 'rate') {
        test = copyToClipboard(this.rateSpreadResult, 'Rate Spread value')
      } else if(type === 'geo') {
        test = copyToClipboard(this.geoCodeResult, 'Geo Code value')
        this.copyGeoCode = true
      }
      this.setAlert({
          title: constant.imageHeaderSuccess,
          msg: test,
          variant: constant.successMessagetype,
      })

    },
    // ULI comments
    async showULIComment() {

      this.ULIcommentsList = []
      this.$bvModal.show('bv-modal-ulicomments')
      this.showSpinner = true

      this.fetchULIComment({
        larDetailId: this.loan.larDetailId,
      })
        .then((a) => {
          this.ULIcommentsList = a
        })
        .finally(() => {
          this.showSpinner = false
        })
    },
    // Geo code
    onClickGeoCode() {
      this.loanAttributes.map((l) => {
        switch(l.name) {
          case 'Street': this.propStreet = l.currentValue || null
           break
          case 'City': this.propCity = l.currentValue || null
           break
          case 'State': this.propState = l.currentValue || null
           break
          case 'ZipCode': this.propZip = l.currentValue || null
           break
          case 'CensusTract': this.censusTract = l.currentValue
        }
      })
      // build address
      this.propertyAddress = this.formatAddress(this.propStreet) + this.formatAddress(this.propCity) +
                             (this.propState ? this.propState + ' ' : '') + (this.propZip ? this.propZip : '')
      // clear prev data
      this.geoCodeResult = null
      this.onClickCalculateGeoCode()
      this.backgroundSpinner = false
      this.showGeoCodeModal = true
    },
    formatAddress(value) {
      return value ? value + ', ' : ' '
    },
    formatDisplay(value) {
      return value ? value + ' ' : ''
    },
    closeGeoCode() {
      // turn off modal and clear user inputs/errors
      this.showGeoCodeModal = false
      this.backgroundSpinner = true
      // this.geoCodeAPIError = false

      if(this.copyGeoCode) {
        setTimeout(() => {
          copyToClipboard(
          this.geoCodeResult,
          'Geo Code value')
        }, 0)
      }

    },
    checkAddressDetails() {
      this.geoCodeErrors.length = 0
      if(this.propCity === null) this.geoCodeErrors.push('City is required')
      if(this.propState === null) this.geoCodeErrors.push('State is required')
      if(this.propZip === null) this.geoCodeErrors.push('Zip Code is required')

      return this.geoCodeErrors.length === 0
    },
    onClickCalculateGeoCode() {
      // check validation
      if(this.checkAddressDetails()) {
        this.showSpinner = true
        this.copyGeoCode = false
        // this.geoCodeAPIError = false
        this.geoCodeResult = null
        let payload = {
        request: {
        property: {
            address: this.propertyAddress,
         }
        }
      }
      this.getGeoCodeValue(payload).then((response) => {
        if(response && response.status === 200) {
          this.geoCodeResult = response.data.raw || null
        }
        // else this.geoCodeAPIError = false

        if(!this.containsOnlyDigits(response.data.raw)) {
            this.setAlert({
              title: constant.imageHeaderError,
              msg: response.data.raw,
              variant: constant.errorMessagetype,
            })
        }
        this.showSpinner = false
      }).catch((error) => {
            this.showSpinner = false
            this.authError = error
            this.setAlert({
              title: constant.imageHeaderError,
              msg: constant.errorMessage,
              variant: constant.errorMessagetype,
            })
         })
      }
    },

   deleteLoan() {
      this.modalDelete = this.$refs.msg1
      this.modalDelete.confirmOkClicked = this.deleteConfrimLoans;
      this.modalDelete.showAsync(
        'Are you sure you want to delete this loan?',
        'Confirm',
        'Delete item'
       );
    },
      deleteConfrimLoans() {
      if (this.deletedOption === 'other' && !this.otherInput.trim()){
        this.showCustomReportIssue = true;

        return;
      }


      let reason = this.deletedOption === 'other' ? this.otherInput : this.deletedOption;
      this.deleteLoanBatch({loanDetailIds: [this.loan.larDetailId], reason: reason})
      .finally( this.$router.push({name: 'hmda-project-details', params: { id: this.loan.projectId}}))
    },
  },
}
</script>
<template>
  <div>
    <BaseSpinner v-if="showSpinner && backgroundSpinner" />
    <BaseModalLayout ref="msg" modal-size="md" />
    <BaseModalLayout ref="msgusc" modal-size="md" />
    <!-- Rate Spread modal -->
    <BaseModalLayout
      :show-modal="showRateSpreadModal"
      modal-title="Rate Spread"
      modal-size="md"
      ok-variant="Calculate"
      cancel-variant="Close"
      @confirmOkClicked="onClickCalculateRateSpread"
      @confirmCancelClicked="closeRateSpread"
    >
    <BaseSpinner v-if="showSpinner" />
    <div class="ml-3 my-2">
      <div class="mt-1 mb-3"><BaseELabel label="Please fill the details below to calculate the Rate Spread" size="md" /></div>
      <div>
        <b-row class="my-2">
          <b-col md="5"><BaseELabel label="Amortization Type" mark-required /></b-col>
          <b-col md="6">
          <BaseDropdown
            v-model="amortizationType"
            v-validate="{ required: true }"
            :field-id="amortizationType"
            :options="amortizationTypes"
            data-vv-as="Amortization Type"
            name="amortizationType"
          ></BaseDropdown>
          <div class="error">
              {{ errors.first('amortizationType') }}
            </div>
          </b-col>
        </b-row>
        <b-row class="my-2">
          <b-col md="5"><BaseELabel label="Rate Lock Date" mark-required /></b-col>
          <b-col md="6">
            <BaseDate
              v-model="rateLockDate"
              v-validate="{ required: true }"
              type="date"
              :field-id="rateLockDate"
              name="rateLockDate"
              data-vv-as="Rate Lock Date"
            ></BaseDate>
            <div class="error">
              {{ errors.first('rateLockDate') }}
            </div>
          </b-col>
        </b-row>
        <b-row class="my-2">
          <b-col md="5"><BaseELabel label="APR" mark-required /></b-col>
          <b-col md="6">
            <BaseEInputText
              v-model="apr"
              v-validate="{ required: true }"
              name="apr"
              data-vv-as="APR"
              type="text"
              size="sm"
              @change="formatApr(apr)"
            />
            <div class="error">
              {{ errors.first('apr') }}
            </div>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col md="5"><BaseELabel label="Action Taken" /></b-col>
          <b-col md="6" class="text-center">{{ actionTaken }}</b-col>
        </b-row>
        <b-row class="my-3">
          <b-col md="5"><BaseELabel label="Reverse Mortage Code" /></b-col>
          <b-col md="6" class="text-center">{{ reverseMortgageCode }}</b-col>
        </b-row>
        <b-row class="my-3">
          <b-col md="5"><BaseELabel label="Loan Term" /></b-col>
          <b-col md="6" class="text-center">{{ loanTerm ? loanTerm + ' year(s)' : '' }}</b-col>
        </b-row>
      </div>
      <div>
        <b-row v-if="rateSpreadResult" class="my-2 text-center">
          <b-col>
            <BaseELabel :label="`Rate Spread value is ${rateSpreadResult}`" size="md" />
            <span class="py-2 ml-2">
                <BaseEButton
                  id="tooltip-target-rate"
                  class="ml-2"
                  icon="copy"
                  variant="icon"
                  @click="copyToClipboardValue('rate')"
                >
                </BaseEButton>
                <b-tooltip
                  target="tooltip-target-rate"
                  class="ml-2"
                  triggers="hover"
                >
                  Copy to Clipboard
                </b-tooltip>
          </span>
          </b-col>
        </b-row>
        <b-row v-else-if="rateSpreadError">
          <b-col>
            <p class="textFont">Unable to calculate Rate Spread. Please correct the data inputs.</p>
          </b-col>
        </b-row>
      </div>
    </div>
    </BaseModalLayout>

    <!-- Geo Code Modal -->
    <BaseModalLayout
      :show-modal="showGeoCodeModal"
      modal-title="Geo Code"
      modal-size="md"
      ok-variant="Calculate"
      cancel-variant="Close"
      hide-ok
      @confirmOkClicked="onClickCalculateGeoCode"
      @confirmCancelClicked="closeGeoCode"
    >
    <BaseSpinner v-if="showSpinner" />
    <div class="ml-3 my-2">
      <b-row>
          <b-col md="5"><BaseELabel label="Property Address:" /></b-col>
          <b-col md="6" class="mt-1">
            {{ formatAddress(propStreet) }} <br/>
            {{ formatDisplay(formatAddress(propCity)) + formatDisplay(propState) + formatDisplay(propZip) }}
          </b-col>
      </b-row>
      <b-row>
        <b-col md="5"></b-col>
          <b-col md="7" class="textFont">
            <div v-if="geoCodeErrors.length"><BaseELabel :label="`City & State or City & Zip is required!`" class="textError" /></div>
          </b-col>
      </b-row>
      <b-row class="my-2">
          <b-col md="5"><BaseELabel label="Current Geo Code:" /></b-col>
          <b-col md="6">
            {{ censusTract }}
          </b-col>
      </b-row>
      <b-row class="my-2">
          <b-col md="5"><BaseELabel label="New Geo Code:" /></b-col>
          <b-col md="6">
            <span v-if="geoCodeResult !== censusTract">{{ geoCodeResult }}</span>
            <span :class="geoCodeResult !== censusTract ? 'py-2 ml-2' : 'py-2 float-right mr-4'">
                <BaseEButton
                  v-if="!geoCodeErrors.length"
                  id="tooltip-target-geo"
                  class="ml-2"
                  icon="copy"
                  :disabled="geoCodeResult === censusTract"
                  variant="icon"
                  @click="copyToClipboardValue('geo')"
                >
                </BaseEButton>
                <b-tooltip
                  target="tooltip-target-geo"
                  class="ml-2"
                  triggers="hover"
                >
                  Copy to Clipboard
                </b-tooltip>
            </span>
          </b-col>
      </b-row>
      <b-row v-if="geoCodeResult === censusTract">
        <b-col>
          <p class="text-center py-2">Census tract is accurate.  No updates needed.</p>
        </b-col>
      </b-row>
      <!-- <b-row v-if="geoCodeAPIError">
          <b-col>
            <p class="textFont">Unable to calculate Geo Code. Please correct the data inputs.</p>
          </b-col>
        </b-row> -->
    </div>
    </BaseModalLayout>

        <BaseModalLayout ref="msg1" modal-size="md">
          <BaseDropdown
            id="text-salutation"
            v-model="deletedOption"
            type="text"
            :options="deletionOptions"></BaseDropdown>

      <div v-if="deletedOption === 'other'">
         <BaseEInputText  v-model="otherInput" type="text" label-content="Input your reason"></BaseEInputText>
      </div>
      <b-row class="mb-4">
        <b-col>
      <div
        v-if="showCustomReportIssue"
        class="error"
        >Reason Is Required
        </div>
        </b-col>

      </b-row>

    </BaseModalLayout>

    <div class="d-flex justify-content-between mb-3">
      <!-- <h4>Loan Attributes</h4> -->
      <div>
        <BaseEButton
          class="ml-0"
          :disabled="!isAnyUnsavedChanges"
          @click="saveChanges"
        >
          Save Changes
        </BaseEButton>
        <BaseEButton @click="onClickRunRules">
          Run Rules
        </BaseEButton>
        <BaseEButton @click="showULIComment">
          ULI History
        </BaseEButton>
      </div>
      <b-modal
      id="bv-modal-ulicomments"
      ref="refuliComments"
      size="xl"
      hide-footer
      title="ULI History"
    >
      <BaseSpinner v-if="showSpinner" />
      <div class="mb-2">Showing all past and current attributes of record</div>
      <b-table-simple responsive hover>
        <thead>
          <b-tr>
            <b-th style="width: 180px">Date</b-th>
            <b-th style="width: 180px">Data Attribute</b-th>
            <b-th style="width: 180px">Changed By</b-th>
            <b-th>Old Value</b-th>
            <b-th>New Value</b-th>
            <b-th>Comment</b-th>
          </b-tr>
        </thead>
        <tbody>
          <b-tr v-for="(b, bi) in ULIcommentsList" :key="bi">
            <b-td class="py-1"> {{ b.date }} </b-td>
            <b-td class="py-1"> {{ b.dataAttributeName  }} </b-td>
            <b-td class="py-1"> {{ b.changedBy }} </b-td>
            <b-td class="py-1"> {{ b.oldValue }} </b-td>
            <b-td class="py-1"> {{ b.newValue }} </b-td>
            <b-td class="py-1"> {{ b.comment }} </b-td>
          </b-tr>
        </tbody>
      </b-table-simple>
    </b-modal>
      <div>
        <BaseEButton @click.prevent="deleteLoan">
          Delete Item
        </BaseEButton>
        <BaseEButton :disabled="disablePrevBtn" @click.prevent="prevLoan">
          &lt;&lt; Previous
        </BaseEButton>
        <BaseEButton :disabled="disableNextBtn" @click.prevent="nextLoan">
          Next &gt;&gt;
        </BaseEButton>
      </div>
    </div>

    <b-row>
      <b-col>
        <b-table-simple
          width="100%"
          borderless
          hover
          small
          caption-top
          responsive
        >
          <thead>
            <b-tr>
              <b-th style="width:40%">Loan Attribute</b-th>
              <b-th>Current Value</b-th>
              <b-th>New Value</b-th>
              <b-th>Comment</b-th>
              <b-th></b-th>
            </b-tr>
          </thead>
          <tbody>
            <OneLoanAttribute
              v-for="(item, index) in loanAttributes"
              :key="`ola_${index}`"
              v-model="item.isChanged"
              :item="item"
              :filter="filter"
              :comments-mandatory="commentsMandate"
              @onClickShowComment="showComment"
              @state-updated="stateUpdated"
              @onClickCustomLoanMethods="onClickCustomLoanMethods"
            />
          </tbody>
        </b-table-simple>
      </b-col>
    </b-row>

    <hr />

    <div class="d-flex justify-content-between">
      <div>
        <BaseEButton
          class="ml-0"
          :disabled="!isAnyUnsavedChanges"
          @click="saveChanges"
        >
          Save Changes
        </BaseEButton>
        <BaseEButton @click="onClickRunRules">
          Run Rules
        </BaseEButton>
      </div>

      <div>
        <div class="mb-3">
          <BaseEButton :disabled="disablePrevBtn" @click.prevent="prevLoan">
            &lt;&lt; Previous
          </BaseEButton>
          <BaseEButton :disabled="disableNextBtn" @click.prevent="nextLoan">
            Next &gt;&gt;
          </BaseEButton>
        </div>
        <div class="text-right">
          <b-link
            @click="
              goToProjectSummary({
                name: 'hmda-project-details',
                params: { id: PROJECT_ID },
              })
            "
          >
            Back to Project Summary
          </b-link>
        </div>
      </div>
    </div>

    <b-row>
      <b-col>
        <div> </div>
      </b-col>
    </b-row>

    <b-modal
      id="bv-modal-comments"
      ref="refComments"
      size="xl"
      hide-footer
      title="Comments"
    >
      <BaseSpinner v-if="showSpinner" />
      <div class="mb-2">{{ commentsfieldName }}</div>
      <b-table-simple responsive hover>
        <thead>
          <b-tr>
            <b-th style="width: 180px">Date</b-th>
            <b-th style="width: 180px">Changed By</b-th>
            <b-th>Old Value</b-th>
            <b-th>New Value</b-th>
            <b-th>Comment</b-th>
          </b-tr>
        </thead>
        <tbody>
          <b-tr v-for="(b, bi) in commentsList" :key="bi">
            <b-td class="py-1"> {{ b.date }} </b-td>
            <b-td class="py-1"> {{ b.changedBy }} </b-td>
            <b-td class="py-1"> {{ b.oldValue }} </b-td>
            <b-td class="py-1"> {{ b.newValue }} </b-td>
            <b-td class="py-1"> {{ b.comment }} </b-td>
          </b-tr>
        </tbody>
      </b-table-simple>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
.textFont {
  font-size: $size-content-font-sm;
  color: $color-status-fail;
}
.textError {
  color: $color-status-fail;
}
</style>
